module.exports = __webpack_public_path__ + "static/media/22ESCWA5.2064a490.jpg";